import { gql } from "@apollo/client";
import { alpha } from "@mui/material";
import { COLOR_BLACK, COLOR_BLACK_LIGHTER, COLOR_WHITE_LIGHTER } from "helpers/colors";
import useData from "helpers/useData";
import Splash from "molecules/Splash";
import Subnav, { SubnavDropdown, SubnavDropdownItem, SubnavToggleLabel } from "molecules/Subnav";
import React from "react";

export default function TeamPagesHeader({ teamId, tab }) {
  const [data] = useData(
    gql`
      query TeamPagesHeader($teamId: ID!) {
        team(id: $teamId) {
          id
          name
          colour
          lastLeague {
            id
            name
          }
          lastSeason {
            id
          }
          org {
            id
            primarySport
          }
        }
        currentUser {
          id
          teams {
            id
            name
            colour
            lastLeague {
              id
              name
            }
          }
        }
      }
    `,
    { teamId },
  );

  const lastSeasonId = data?.team?.lastSeason?.id;

  return (
    <>
      <Splash
        loading={!data}
        color={COLOR_BLACK_LIGHTER}
        title={data?.team?.name}
        descriptionHeader="League"
        descriptionValue={data?.team?.lastLeague?.name}
      />
      <div
        style={{
          backgroundColor: COLOR_WHITE_LIGHTER,
          borderBottom: `1px solid ${alpha(COLOR_BLACK, 0.1)}`,
        }}
      >
        <Subnav wrap={false}>
          {data?.currentUser?.teams.length > 1 && (
            <SubnavDropdown text={data?.team?.name} description={data?.team?.lastLeague?.name}>
              {data?.currentUser?.teams.map((t) => (
                <SubnavDropdownItem
                  key={t.id}
                  text={t.name}
                  description={t.lastLeague?.name}
                  selected={t.id === teamId}
                  href={`/team/${t.id}`}
                >
                  {t.name}
                </SubnavDropdownItem>
              ))}
            </SubnavDropdown>
          )}
          <SubnavToggleLabel text="Roster" checked={tab === "roster"} href={`/team/${teamId}/roster`} />
          <SubnavToggleLabel
            text="Games"
            checked={tab === "games"}
            disabled={!lastSeasonId}
            href={`/team/${teamId}/games?seasonId=${lastSeasonId}`}
          />
          {!["pickleball", "netball", "volleyball"].includes(data?.team?.org?.primarySport) && (
            <>
              <SubnavToggleLabel
                text="Leaderboard"
                checked={tab === "leaderboard"}
                disabled={!lastSeasonId}
                href={`/team/${teamId}/leaderboard?seasonId=${lastSeasonId}`}
              />
              <SubnavToggleLabel
                text="Performance"
                checked={tab === "performance"}
                disabled={!lastSeasonId}
                href={`/team/${teamId}/performance?seasonId=${lastSeasonId}`}
              />
              <SubnavToggleLabel
                text="Season"
                checked={tab === "season"}
                disabled={!lastSeasonId}
                href={`/team/${teamId}/season?seasonId=${lastSeasonId}`}
              />
            </>
          )}
        </Subnav>
      </div>
    </>
  );
}
